export default "/sell-products-rack.175027f0-05692f.png";